module.exports = __webpack_public_path__ + "static/media/60810036-DTf1wSgs.be7c29c4.JPG";